/* eslint-disable jsx-a11y/anchor-is-valid */
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { KTableProvider } from '../../../../../../contexts/KTableProvider'
import { useCentral } from '../../../../../../hooks/useCentral'
import { MasiveUploadUser } from '../form/masive'
import { MasiveAutomaticUploadUser } from '../form/masive-automatic'
import { TableUser } from './Column'
import { UpdateMasiveUser } from '../form/update-masive'

const TableUserWrapper = () => {
  const { isAllowed } = useCentral()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Usuario</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
            {isAllowed('MASIVO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Carga Automática</Tab>
            )}
            {isAllowed('MASIVO') && (
              <Tab className={'sdx_sub_tab_panel_option'}>Actualización Masiva</Tab>
            )}
          </TabList>
          <TabPanel>
            <TableUser />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <MasiveUploadUser />
            </TabPanel>
          )}
          {isAllowed('MASIVO') && (
            <TabPanel>
              <MasiveAutomaticUploadUser />
            </TabPanel>
          )}
          {isAllowed('MASIVO') && (
            <TabPanel>
              <UpdateMasiveUser />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export { TableUserWrapper }
